import { render } from "./RIReservationDetails.vue?vue&type=template&id=60c19386&scoped=true"
import script from "./RIReservationDetails.vue?vue&type=script&lang=js"
export * from "./RIReservationDetails.vue?vue&type=script&lang=js"

import "./RIReservationDetails.vue?vue&type=style&index=0&id=60c19386&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c19386"]])

export default __exports__